import { InjectionToken } from '@angular/core';

export const PARTNER_TOKEN = new InjectionToken<string>('partner_id');
export const MEDIA_TOKEN = new InjectionToken<string>('media_token');
export const USE_SLASH_TOKEN = new InjectionToken<string>('use_slash');
